<template>
	<div
		ref="scrollContainer"
		:class="['content-index', { 'scroll-style': !isBannerShow }, `content-body-${activeGameId}`]"
		:style="{ height: containerHeight ? containerHeight + 'px' : '100vh' }"
		@scroll="handleScroll"
	>
		<div :class="['bg-img', `bg-img-${activeGameId}`]"></div>
		<div class="header" ref="header">
			<div class="logo"></div>
			<!-- 顶部搜索 -->
			<search ref="search" :gameId="activeGameId" @search="search"></search>
		</div>
		<div class="content-header">
			<div class="new-man" v-if="isBannerShow && isShowNewUser" @click="goNewPeopleActivity"></div>
			<div class="sticky">
				<!-- 游戏选择 -->
				<div class="game-select-box" ref="gameSelectBox">
					<!-- <van-tabs
              class="game-tabs"
              v-model="activeGameId"
              swipe-threshold="3"
            >
              <van-tab
                v-for="(item, index) in gameList"
                :key="item.id"
                :title="item.name"
                :name="item.id"
              >
                <template v-slot:title="slotProps">
                  <div
                    :class="[
                      'game-name',
                      { active: item.id == activeGameId },
                      item.id == activeGameId && `active-${item.id}`
                    ]"
                  >
                    {{ item.id != activeGameId ? item.name : "" }}
                  </div>
                </template>
              </van-tab>
            </van-tabs>
            <div class="all-game-box" @click="toAllGame()">
              <i></i>
              <span>全部游戏</span>
            </div>
            -->
				</div>
				<!-- 游戏筛选 -->
				<div :class="['game-filter-box', { 'game-filter-box-b': isBannerShow }]">
					<filter-game
						:gameId="activeGameId"
						:gameType="2"
						:data="filterData"
						@handleSortFilter="handleSortFilter"
						@confirmFilter="confirmFilter"
					></filter-game>
				</div>

				<!-- 热词 -->
				<ul class="hot-key-box" v-if="filterData && filterData.keyWordList && filterData.keyWordList.length">
					<li
						:class="[
							'hot-key',
							{
								active: searchTexts.includes(item.key) || searchSkins.includes(item.skinId)
							}
						]"
						v-for="(item, index) in filterData.keyWordList"
						:key="index"
						@click="handleHotSearchTerms(item)"
					>
						{{ item.key }}
					</li>
				</ul>
			</div>
		</div>

		<div :class="['content-body']">
			<!-- 游戏列表 -->
			<van-list
				v-model="loading"
				:finished="finished"
				finished-text=""
				loading-text="加载中..."
				:immediate-check="false"
				@load="queryGameList"
			>
				<template v-if="goodsList && goodsList.length">
					<!-- 游戏列表 -->
					<game-item
						v-for="(item, index) in goodsList"
						:key="index"
						:item="item"
						:index="index"
						:game-id="activeGameId"
						:pageSource="1"
						:important-params="importantParams"
					/>
				</template>

				<!-- 无数据 -->
				<div v-else-if="!(goodsList && goodsList.length) && !loading" class="empty">暂无数据~</div>
			</van-list>

			<div class="more-account-box" v-if="goodsList && goodsList.length" @click="toAccountList()">
				查看更多账号
				<van-icon name="arrow" />
			</div>

			<!-- 页脚 -->
			<page-footer v-if="!loading"></page-footer>

			<div class="footer-bottom"></div>
		</div>

		<!-- 新人专享 -->
		<div class="new-man-box-mask" v-if="newManMask" @click="closeNewManMask">
			<img src="~@/images/new-home/new-man-mask.png" alt="" @click="goNewPeopleActivity" />
		</div>

		<!-- 底部导航 -->
		<menu-foot current="index"></menu-foot>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import menuFoot from '../../components/menu/menu.vue';
import search from '../../components/search.vue';
import filterGame from '../../components/filter-game.vue';
import gameItem from '../../components/game-item.vue';
import pageFooter from '../../components/page-footer.vue';
import { getUrlParams } from '@/js/common';

import {
	GetGoodsListStore,
	queryGameArea,
	GetImportantParamsStore,
	GetGameQueryConfigStore,
	getConfigPrize
} from '../../service/getData';
export default {
	name: 'NewHome',
	data() {
		return {
			gameList: [
				{
					id: 1109,
					name: '王者荣耀'
				},
				{
					id: 1882,
					name: '和平精英'
				},
				{
					id: 1525,
					name: '火影忍者'
				}
			],
			goodsList: [],
			importantParams: {},
			activeGameId: 0,
			system: '',
			loading: false,
			finished: false,
			// 首页加载列表请求2次数据，为了可见org域名下的隐私协议
			listCount: 1,
			pageIndex: 1,
			pageSize: 20,
			gameType: '',
			systemType: '',
			isBannerShow: true,
			sortCondition: 'countBuyMonth##DESC',
			advancedFilterData: {},
			filterData: {},
			searchTexts: [],
			searchSkins: [],
			newManMask: false,
			keyWord: '',
			scrollTop: 0,
			containerHeight: 0,
			scrollContainer: null,
			gameSelectBoxOffsetTop: 402
		};
	},
	components: {
		search,
		filterGame,
		gameItem,
		menuFoot,
		pageFooter
	},
	watch: {
		async activeGameId() {
			this.clearCache();
			this.getImportantParams();
			this.getGameQueryConfig();
			await this.getQueryGameArea();
			await this.queryGameList();
		},
		$route(to, from) {
			if (to.path == '/') {
				// window.open('?gameId=',sessionStorage.getItem('indexgameId'))
				if (this.goodsList && this.goodsList.length && this.$refs.scrollContainer) {
					setTimeout(() => {
						this.$refs.scrollContainer.scrollTop = this.scrollTop;
					}, 200);
				}
			}
		}
	},
	computed: {
		...mapState(['isShowNewUser', 'userInfo'])
	},
	async created() {
		if (this.gameList && this.gameList.length > 0) {
			this.activeGameId = this.gameList[0].id;
		}
		this.judgmentSystem();
		// 接口获取是否展示新人活动
		await this.getConfigPrize();
		// 新人专享
		let newManMask = localStorage.getItem('newManMask') || false;
		if (!newManMask && this.isShowNewUser) {
			this.newManMask = true;
		}
	},
	mounted() {
		this.activeGameId = this.$route.query.gameId || sessionStorage.getItem('indexgameId') || 1109;
		if (this.$route.query.gameId) {
			sessionStorage.setItem('indexgameId', this.$route.query.gameId);
		}
		this.setContainerHeight();
		window.addEventListener('resize', this.setContainerHeight);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.setContainerHeight);
	},
	methods: {
		getDOMInfo() {
			try {
				let availableWidth = window.innerWidth;
				if (availableWidth <= 750) {
					this.gameSelectBoxOffsetTop = parseFloat(((availableWidth / 750) * 402).toFixed(2));
				} else {
					this.gameSelectBoxOffsetTop = 402;
				}
			} catch (e) {
				const header = this.$refs.header;
				const scrollContainer = this.$refs.scrollContainer;
				this.scrollContainer = scrollContainer;
				const gameSelectBox = this.$refs.gameSelectBox;
				const rect = gameSelectBox.getBoundingClientRect();
				const offsetTop = rect.top;
				this.gameSelectBoxOffsetTop = parseInt(offsetTop - header.offsetHeight);
			}
		},
		// 游戏选择
		handlerGameSelect(item) {
			this.activeGameId = item.id;
		},

		// 判断系统
		judgmentSystem() {
			let system = navigator.userAgent;
			if (system.indexOf('Android') > -1 || system.indexOf('Linux') > -1) {
				this.system = '0';
			} else if (!!system.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
				this.system = '1';
			} else {
				this.system = '';
			}
		},

		// 所有游戏
		toAllGame() {
			this.$router.push('/goodsAll');
		},

		// 游戏列表
		async queryGameList() {
			this.loading = true;
			if (!this.activeGameId || this.listCount == 2) {
				// 没有游戏id跳出
				this.loading = false;
				return false;
			}
			let searchTexts = [];
			if (this.keyWord) {
				searchTexts = [this.keyWord];
			}
			if (this.searchTexts && this.searchTexts.length) {
				searchTexts = searchTexts.concat(this.searchTexts);
			}

			let params = {
				pageIndex: this.pageIndex,
				pageSize: this.pageSize,
				xbUserId: this.userInfo.userId,
				gameId: this.activeGameId,
				businessNo: this.$store.state.businessNo,
				system: this.gameType == 2 && this.systemType == 3 ? this.system : '',
				searchTexts,
				searchSkins: this.searchSkins,
				sortCondition: this.sortCondition,
				judgeConstraintFlag: 0,
				...this.advancedFilterData
			};
			const { data } = await GetGoodsListStore(params);
			if (data.result.data.length < 9) {
				// 没数据了，结束触底加载
				this.finished = true;
			}
			if (data.code == '1') {
				this.goodsList = this.goodsList.concat(data.result.data);
				this.pageIndex = this.pageIndex + 1;
				this.listCount++;
				this.loading = false;
			}
		},

		// 获取过滤条件
		getGameQueryConfig() {
			GetGameQueryConfigStore({ gameId: this.activeGameId }).then((res) => {
				if (res.data.code == '1') {
					this.filterData = res.data.result;
				}
			});
		},

		// 获取重要参数
		getImportantParams() {
			GetImportantParamsStore({ gameId: this.activeGameId }).then((res) => {
				if (res.data.code == '1' && res.data.result) {
					this.importantParams = res.data.result;
				}
			});
		},

		// 获取游戏信息
		async getQueryGameArea() {
			await queryGameArea({ serverId: this.activeGameId }).then((res) => {
				if (res.data.code == '1' && res.data.result) {
					this.gameType = res.data.result.gameType || '';
					this.systemType = res.data.result.systemType || '';
				}
			});
		},

		/*
		 * 清除缓存
		 * @param type 1 清除部分，筛选的数据和热词不清楚，不传值全部清除
		 */
		clearCache(type) {
			if (type == 1) {
				this.goodsList = [];
				this.pageIndex = 1;
				this.listCount = 1;
				this.loading = false;
				this.finished = false;
				this.isBannerShow = true;
			} else {
				this.goodsList = [];
				this.pageIndex = 1;
				this.listCount = 1;
				this.loading = false;
				this.finished = false;
				this.isBannerShow = true;
				this.keyWord = '';
				this.sortCondition = 'countBuyMonth##DESC';
				this.advancedFilterData = {};
				this.searchTexts = [];
				this.searchSkins = [];
			}
		},
		// 排序
		handleSortFilter(e) {
			this.clearCache(1);
			this.sortCondition = e.sortCondition ? e.sortCondition : '';
			this.queryGameList();
		},

		// 筛选
		confirmFilter(e) {
			this.clearCache(1);
			this.advancedFilterData = e;
			this.queryGameList();
		},

		// 更多账号
		toAccountList() {
			let index = this.gameList.findIndex((item) => {
				return item.id == this.activeGameId;
			});
			this.$router.push({
				path: 'goodslist',
				query: {
					gameId: this.activeGameId,
					gameName: index > -1 ? this.gameList[index].name : '',
					gameType: this.gameType
				}
			});
		},

		// 热门搜索词
		handleHotSearchTerms(item) {
			if (item.keyType == 1) {
				if (this.searchTexts.includes(item.key)) {
					this.searchTexts.splice(this.searchTexts.indexOf(item.key), 1);
				} else {
					if (this.searchTexts.length + this.searchSkins.length >= 5) {
						this.$toast('最多选择5个关键词');
						return;
					}
					this.searchTexts.push(item.key);
				}
			} else if (item.keyType == 2) {
				if (this.searchSkins.includes(item.skinId)) {
					this.searchSkins.splice(this.searchSkins.indexOf(item.skinId), 1);
				} else {
					if (this.searchTexts.length + this.searchSkins.length >= 5) {
						this.$toast('最多选择5个关键词');
						return;
					}
					this.searchSkins.push(item.skinId);
				}
			}
			this.clearCache(1);
			this.keyWord = '';
			this.$refs.search.clearSearch();
			this.queryGameList();
		},
		closeNewManMask() {
			this.newManMask = false;
			localStorage.setItem('newManMask', true);
		},
		// 点击新人浮窗
		goNewPeopleActivity() {
			if (!(this.$store.state.userInfo && this.$store.state.userInfo.authorization)) {
				this.$router.push({
					path: '/login',
					query: {
						redirect: `/welfare?channel=${
							this.$store.state.channel || this.$store.state.businessNo
						}&clientId=6`
					}
				});
				return false;
			}
			this.$router.push({
				path: '/welfare',
				query: {
					channel: this.$store.state.channel || this.$store.state.businessNo,
					clientId: 6
				}
			});
		},
		// 搜索
		search(e) {
			this.clearCache(1);
			this.searchTexts = [];
			this.searchSkins = [];
			this.keyWord = e;
			this.queryGameList();
		},
		// 滚动监听
		handleScroll(event) {
			const { scrollTop, scrollHeight, clientHeight } = event.target;
			this.scrollTop = scrollTop;
			if (this.gameSelectBoxOffsetTop <= scrollTop) {
				this.isBannerShow = false;
			} else {
				this.isBannerShow = true;
			}
		},
		setContainerHeight() {
			this.$nextTick(() => {
				setTimeout(() => {
					this.getDOMInfo();
				}, 1000);
			});
			this.containerHeight = window.innerHeight - document.documentElement.clientTop;
		},
		// 获取新人专享
		async getConfigPrize() {
			// 用户未登录
			if (!(this.$store.state.userInfo && this.$store.state.userInfo.authorization)) {
				this.$store.commit('setIsShowNewUser', true);
				return false;
			}
			// 用户已登录
			let params = {
				Authorization: this.$store.state.userInfo.authorization,
				appChannel: this.$route.query.channel || this.$store.state.businessNo
			};
			const { data } = await getConfigPrize(params);
			if (data.code == '1' && data.success) {
				if (data.result.userType == 10 || data.result.userType == 11) {
					this.$store.commit('setIsShowNewUser', true);
				} else {
					this.$store.commit('setIsShowNewUser', false);
				}
			}
		}
	}
};
</script>
<style lang="scss" scoped>
@import '../../style/common';
img {
	object-fit: contain;
}
.content-index {
	width: 100%;
	height: 100vh;
	position: relative;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	align-items: center;
	background: #f5f6fa;
	overflow-y: scroll;
	padding-top: 0.88rem;
	.bg-img {
		position: absolute;
		top: 0;
		left: 50%;
		transform: translateX(-50%);
		z-index: 0;
		width: 7.5rem;
		height: 8.3rem;
		background-size: 7.5rem 8.3rem !important;
		transition: all 0.5s;
	}
	.bg-img-1109 {
		background: url('~@/images/gameHome/wzry.png') no-repeat center center;
	}
	.bg-img-1882 {
		background: url('~@/images/gameHome/hpjy.png') no-repeat center center;
	}
	.bg-img-1525 {
		background: url('~@/images/gameHome/hyrz.png') no-repeat center center;
	}

	.header {
		width: 7.5rem;
		height: 0.88rem;
		padding: 0.1rem 0.24rem 0;
		position: fixed;
		top: 0;
		left: 50%;
		transform: translateX(-50%);
		z-index: 200;
		display: flex;
		align-items: center;
		justify-content: space-between;
		.logo {
			width: 1.08rem;
			height: 0.4rem;
			margin-right: 0.24rem;
			background: url('~@/images/new-home/logo-b.png') no-repeat center center;
			background-size: 100%;
		}
	}
	.content-header {
		// flex-shrink: 0;
		width: 7.5rem;
		height: 6.1rem;
		padding: 0 0.24rem 0.1rem;
		background: transparent;
		position: relative;
		z-index: 100;

		.new-man {
			position: absolute;
			top: 2.46rem;
			left: 50%;
			transform: translateX(-50%);
			z-index: 1;
			width: 7.06rem;
			height: 1.24rem;
			background: url('~@/images/new-home/new-man-big.png') no-repeat center center;
			background-size: 100%;
		}

		.game-select-box {
			margin-top: 3.82rem;
			width: 100%;
			// height: 0.88rem;
			display: flex;
			align-items: center;
			justify-content: space-between;
			//transition: all 0.3s;
			//   /deep/ .game-tabs {
			//     height: 100%;
			//     width: 4.94rem;
			//     .van-tabs__wrap {
			//       height: 100%;
			//       .van-tabs__nav {
			//         padding: 0;
			//         background-color: transparent;
			//         .van-tab {
			//           height: 100%;
			//           padding: 0;
			//           text-align: center;
			//           &:not(:first-of-type) {
			//             margin-left: 0.38rem;
			//           }
			//           .game-name {
			//             width: 1.25rem;
			//             height: 0.4rem;
			//             font-weight: 500;
			//             font-size: 0.3rem;
			//             color: #ffffff;
			//             line-height: 0.4rem;
			//             white-space: nowrap;
			//           }
			//           .active {
			//             width: 1.6rem;
			//             background: url("~@/images/new-home/game-name-gather.png")
			//               no-repeat;
			//             background-size: 4.26rem 2.14rem;
			//             position: relative;
			//           }
			//           .active-1109 {
			//             background-position: -0.24rem -0.24rem;
			//           }
			//           .active-1882 {
			//             background-position: -0.24rem -0.88rem;
			//           }
			//           .active-1525 {
			//             background-position: -0.24rem -1.52rem;
			//           }
			//         }
			//       }
			//     }
			//     .van-tabs__line {
			//       bottom: 0rem;
			//       display: block;
			//       width: 0.58rem;
			//       height: 0.1rem;
			//       background: url("~@/images/new-home/active-icon-b.png") no-repeat;
			//       background-size: 100%;
			//     }
			//   }
			//   .all-game-box {
			//     width: 1.6rem;
			//     height: 100%;
			//     display: flex;
			//     align-items: center;
			//     justify-content: space-between;
			//     > i {
			//       display: block;
			//       width: 0.4rem;
			//       height: 0.4rem;
			//       background: url("~@/images/new-home/all-game-icon.png") no-repeat;
			//       background-size: 100%;
			//     }
			//     > span {
			//       font-weight: 500;
			//       font-size: 0.3rem;
			//       color: #ffffff;
			//       line-height: 0.4rem;
			//       white-space: nowrap;
			//     }
			//   }
		}

		/deep/ .game-filter-box {
			// margin-top: 3.82rem;
			width: 100%;
		}

		/deep/ .game-filter-box-b {
			.van-dropdown-menu {
				.van-dropdown-menu__bar {
					.van-dropdown-menu__item {
						.van-dropdown-menu__title {
							.van-ellipsis {
								color: #ffffff;
							}
							&::after {
								background: url('~@/images/new-home/down-icon.png') no-repeat;
								background-size: 100%;
							}
						}
					}
				}
			}
			.filter-box {
				color: #ffffff;
				.filter-icon {
					background: url('~@/images/new-home/filter-icon.png') no-repeat;
					background-size: 100%;
				}
				.filter-num {
					background: rgba($color: #ffffff, $alpha: 0.2);
					color: #ffffff;
				}
			}
		}
	}
	.content-body {
		// margin-top: -0.8rem;
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	// .content-body-1109{
	//   background: #4D6AB7;
	//   // background: #96adec;
	// }
	// .content-body-1882{
	//   background: #414444;
	// }
	// .content-body-1525{
	//   background: #250505;
	// }

	.hot-key-box {
		width: calc(7.5rem - 0.24rem);
		display: flex;
		align-items: center;
		justify-content: flex-start;
		overflow-x: scroll;
		.hot-key {
			padding: 0.18rem;
			background: rgba(255, 255, 255, 0.9);
			border-radius: 0.12rem;
			font-weight: 400;
			font-size: 0.24rem;
			color: #333333;
			flex-shrink: 0;
			margin-left: 0.16rem;
		}
		.active {
			background: #508aff !important;
			color: #ffffff;
		}
	}

	.van-list {
		margin-top: 0.16rem;
		position: relative;
		z-index: 1;
	}
	.empty {
		width: 100%;
		font-size: 0.24rem;
		color: #a2a0aa;
	}
	.more-account-box {
		flex-shrink: 0;
		width: 7.02rem;
		height: 0.72rem;
		display: flex;
		align-items: center;
		justify-content: center;
		font-weight: 500;
		font-size: 0.26rem;
		color: #ffffff;
		line-height: 0.36rem;
		background: linear-gradient(90deg, #5592fc 0%, #6dcfff 100%);
		border-radius: 0.36rem;
		animation: breathing 1s infinite;
		/deep/ .van-icon {
			color: #ffffff;
			margin-left: 0.08rem;
			font-size: 0.26rem;
		}
	}

	.footer-bottom {
		width: 100%;
		height: 1.5rem;
		flex-shrink: 0;
	}
	.new-man-box-mask {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 1001;
		background: rgba(0, 0, 0, 0.5);
		> img {
			position: absolute;
			top: 3.38rem;
			left: 0;
			width: 100%;
			height: 3.56rem;
		}
	}
}
.content-body-1109 {
	background: #4d6ab7;
	// background: #96adec;
}
.content-body-1882 {
	background: #414444;
}
.content-body-1525 {
	background: #250505;
}

.scroll-style {
	.bg-img {
		opacity: 0;
		z-index: -1;
	}
	.header {
		background: #fff;
		.logo {
			background: url('~@/images/new-home/logo-l.png') no-repeat center center;
			background-size: 100%;
		}
		/deep/ .search {
			background: #f5f5f7;
		}
	}
	.content-header {
		background: #ffffff;
		// box-shadow: 0 0.01rem 0 rgba(0, 0, 0, 0.08);
		.sticky {
			padding: 0 0.24rem 0.1rem;
			width: 7.5rem;
			position: fixed;
			top: 0.88rem;
			left: 50%;
			transform: translateX(-50%);
			z-index: 200;
			background: #fff;
		}
		.game-select-box {
			margin-top: 0;
			/deep/ .game-tabs {
				.van-tabs__wrap {
					.van-tabs__nav {
						.van-tab {
							.game-name {
								color: #333333;
							}
							.active-1109 {
								background-position: -2.4rem -0.24rem;
							}
							.active-1882 {
								background-position: -2.4rem -0.88rem;
							}
							.active-1525 {
								background-position: -2.4rem -1.52rem;
							}
						}
					}
				}
				.van-tabs__line {
					background: url('~@/images/new-home/active-icon-l.png') no-repeat;
					background-size: 100%;
				}
			}
			.all-game-box {
				> i {
					background: url('~@/images/new-home/all-game-icon-h.png') no-repeat;
					background-size: 100%;
				}
				> span {
					color: #333333;
				}
			}
		}
		/deep/ .game-filter-box {
			.van-dropdown-menu {
				.van-dropdown-item {
					margin-top: -0.88rem;
				}
			}
		}
	}
	.hot-key-box {
		.hot-key {
			background: #f2f2f2;
		}
	}
}

@keyframes breathing {
	0% {
		transform: scale(1);
	}
	50% {
		transform: scale(1.05);
	}
	100% {
		transform: scale(1);
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/home/gameHome.vue